import type { AxiosResponse } from "axios";

import { api } from "@/api/api";
import { BnplTrackingEvents, rudderAnalytics } from "@/lib/rudderstack";
import type {
  CreateOrderInputDto,
  CreateOrderOutputDto,
} from "@/types/codegen";

import { type BnplPaymentProvider, PurchaseStatus } from "./types";

export const bnplPaymentProvider: BnplPaymentProvider = {
  initiatePayment: async ({
    availabilityTokens,
    sessionId,
    otp,
    promoCode,
  }) => {
    const response = await api.post<
      CreateOrderOutputDto,
      AxiosResponse<CreateOrderOutputDto>,
      CreateOrderInputDto
    >("/orders", {
      availabilityTokens,
      promoCode,
      provider: "BNPL",
    });

    const orderId = response.data.data.bnplSession?.orderId;
    if (!orderId) {
      throw new Error("Invalid response from API: Missing order ID");
    }

    try {
      await api.post("/transactions/aqsati/validate-installment-with-otp", {
        sessionId,
        otp,
        orderId,
      });
      rudderAnalytics.track(BnplTrackingEvents.USER_PASSED_BNPL_OTP);
      return {
        orderId,
        status: PurchaseStatus.SUCCESSFUL,
      };
    } catch (error) {
      console.error("Error validating installment with OTP:", error);
      rudderAnalytics.track(BnplTrackingEvents.USER_FAILED_BNPL_OTP);
      throw error;
    }
  },
};
